import { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router';

const defaultCookieExpirationTime: number = 20 * 60 * 1000; // 20 min
function setCookie(
  name: string,
  value: string,
  time = defaultCookieExpirationTime
) {
  const date = new Date(Date.now() + time);
  const expires = '; expires=' + date.toUTCString();
  document.cookie = `${name}=${value || ''}${expires}; path=/`;
}

export const useAsidQueryParam = () => {
  const location = useLocation();
  const history = useHistory();

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const asid = searchParams.get('asid') ?? '';

    if (asid) {
      setCookie('ASID', asid);

      searchParams.delete('asid');
      history.replace({ search: searchParams.toString() });
    }
  }, [location, history]);
};
